import { Extension } from '@tiptap/core';
import { ZyDefnBlock, ZyDefnBlockHeadless } from './extensions/zydefn-block-extension';
import { ZyDefn, ZyDefnHeadless } from './extensions/zydefn-inline-extension';
import ZyDefnTerm from './extensions/zydefn-term-extension';

export const ZyDefinitionHeadless = Extension.create({
    name: 'ZyDefinition',
    addExtensions() {
        return [ZyDefnHeadless, ZyDefnBlockHeadless, ZyDefnTerm];
    },
});

export const ZyDefinition = ZyDefinitionHeadless.extend({
    addExtensions() {
        return [ZyDefn, ZyDefnBlock, ZyDefnTerm];
    },
});

export default ZyDefinition;
